<template>
  <RevCard
    class="p-24"
    data-qa="explanation-block"
    data-test="explanation-block"
  >
    <XrStep
      :description="i18n(translations.informationSectionCreditCardDescription)"
      number="1"
      :title="i18n(translations.informationSectionCreditCardTitle)"
    />

    <XrStep
      :description="
        i18n(translations.informationSectionDeliveryDateDescription)
      "
      number="2"
    >
      <template #title>
        <span data-qa="delivery-date" data-test="delivery-date">
          {{
            i18n(translations.informationSectionDeliveryDateTitle, {
              min: i18n.date(new Date(deliveryDate.min), DATE_FORMAT_DELIVERY),
              max: i18n.date(new Date(deliveryDate.max), DATE_FORMAT_DELIVERY),
            })
          }}
        </span>
      </template>
    </XrStep>

    <XrStep
      :description="
        i18n(translations.informationSectionReturnDeadlineDescription)
      "
      number="3"
    >
      <template #title>
        <span data-qa="deadline-date" data-test="deadline-date">
          {{
            i18n(translations.informationSectionReturnDeadlineTitle, {
              deadline: i18n.date(new Date(deadline), DATE_FORMAT_DEADLINE),
            })
          }}
        </span>
      </template>
    </XrStep>

    <XrStep
      :description="i18n(translations.informationSectionAllDoneDescription)"
      is-last
      :title="i18n(translations.informationSectionAllDoneTitle)"
    >
      <template #icon>
        <IconCheckInCircle size="24" />
      </template>
    </XrStep>
  </RevCard>
</template>

<script setup lang="ts">
import type { DateDate } from '@backmarket/http-api/src/standards/DateDate'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'

import XrStep from '~/scopes/customer-care/resolution/components/ExpressReplacement/details/XrStep/XrStep.vue'
import {
  DATE_FORMAT_DEADLINE,
  DATE_FORMAT_DELIVERY,
} from '~/scopes/customer-care/resolution/pages/express-replacement/details/ExpressReplacementDetails.constants'

import translations from './XrInformationSection.translations'

interface ExplanationBlockProps {
  deliveryDate: {
    min: DateDate
    max: DateDate
  }
  deadline: string
}

defineProps<ExplanationBlockProps>()

const i18n = useI18n()
</script>
